import apiService from './apiService';
import { POST } from './executer';

export interface TioCurrentWeatherData {
  temperature: number | null;
  heatIndex: number | null;
  wbgt: number | null;
  trackTemperature: number | null;
  solarGHI: number | null;
  lightIntensity: number | null;
}

class TomorrowIoTimelineService {
  /**
   * Get weather data from Tomorrow.io Timelines API
   * @param latitude - Circuit latitude
   * @param longitude - Circuit longitude
   * @param timestamp - Optional ISO timestamp for specific time queries
   * @returns The weather data (already unwrapped by executer)
   */
  async getCurrentWeather(
    latitude: number,
    longitude: number,
    timestamp?: string
  ): Promise<TioCurrentWeatherData> {
    // Note: The executer automatically unwraps response.data.data,
    // so response.data here is already TioCurrentWeatherData
    const response = await apiService.client.execute<TioCurrentWeatherData>(
      POST,
      '/api/tio-timelines/current',
      { latitude, longitude, timestamp }
    );

    if (!response.success || !response.data) {
      throw new Error('Failed to fetch weather from Tomorrow.io');
    }

    return response.data;
  }
}

const tomorrowIoTimelineService = new TomorrowIoTimelineService();
export default tomorrowIoTimelineService;
